import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationHostTypeService } from 'rome-library';
import { CaseFilterStore } from '../../interfaceTypes/broker/broker-case-hub/services/case-filter-store';
import { States } from './../../shared/constants/states';
import { StateService } from './state.service';
import { TokenStore } from './token.store';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class BrokerStateService extends StateService {
  constructor(
    private readonly router: Router,
    private readonly caseFilterStore: CaseFilterStore,
    private readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly tokenStore: TokenStore,
    private readonly userService: UserService
  ) {
    super();
  }

  public getUserProfileState(): string {
    return States.BrokerProfile;
  }

  public getAccessControllerState(): string {
    return States.AccessController;
  }

  public getHelpCenterState(): string {
    return States.BrokerHelpCenter;
  }

  public getAfterLoginState(): string {
    return States.BrokerCaseHub;
  }

  /* eslint-disable no-void*/
  public goToCaseHub(): void {
    const user = this.userService.getUser();
    const userContext = this.tokenStore.getUserContext();

    if (userContext.IsFirmStartingInTheFuture) {
      void this.router.navigate([this.applicationHostTypeService.getCode(), States.WritingBusiness, user.UserId]);
    } else if (this.router.url.indexOf(States.BrokerCaseHub) !== -1) {
      this.caseFilterStore.notifyOnCaseHubReload();
    } else {
      /* eslint-disable-next-line no-void */
      void this.router.navigate(['/', this.applicationHostTypeService.getCode(), States.BrokerCaseHub]);
    }
  }

  public goToCaseOverview(caseId: string): void {}

  public goToCaseMessaging(caseId: string): void {
    /* eslint-disable-next-line no-void */
    void this.router.navigate([
      '/',
      this.applicationHostTypeService.getCode(),
      States.BrokerCaseOverview,
      caseId,
      States.BrokerCaseMessaging
    ]);
  }
}
